import { MutationTree, ActionTree, GetterTree } from 'vuex'

import {
  AUTH_SET_TOKEN,
  AUTH_SET_IAT,
  AUTH_SET_SETUP_COMPLETE,
  AUTH_SET_OTP_TOKEN,
  AUTH_SET_OTP_NUMBER,
  AUTH_SIGN_OUT,
  AUTH_SET_OTP_TYPE,
  AUTH_DISPATCH_RESEND_OTP,
  AUTH_DISPATCH_SIGNUP,
  AUTH_DISPATCH_LOGIN_SINGPASS,
  AUTH_DISPATCH_LOGIN,
  AUTH_DISPATCH_TOKEN_NACCC,
  AUTH_DISPATCH_VERIFY_OTP,
  AUTH_DISPATCH_SET_NRIC,
  AUTH_DISPATCH_SET_EMAIL,
  AUTH_DISPATCH_LOAD_PROFILE,
  AUTH_DISPATCH_REMOVE_NRIC,
  AUTH_DISPATCH_LOAD_USER_SINGPASS,
  AUTH_DISPATCH_LOGOUT,
  AUTH_SET_REDIRECT,
  AUTH_SET_CREDENTIAL,
  AUTH_SET_OTP_SENT_TIME,
  AUTH_UNSET_OTP_SENT_TIME,
  AUTH_SET_PROFILE,
  AUTH_SET_ISVERIFY_SINGPASS,
  AUTH_SET_USER_SINGPASS,
  AUTH_SET_ISFOUND_ANOTHER_ACCOUNT,
  AUTH_SET_STATUS_SINGPASS,
  AUTH_SET_ERROR_SINGPASS,
  AUTH_SET_FORCE_REDIRECT,
  AUTH_SET_SESSION,
  AUTH_GIFT_INFO,
  AUTH_GIFT_REDEEM,
  AUTH_EXPIRED_TOKEN,
  AUTH_SET_OTP_EMAIL,
  AUTH_EXPIRED_TOKEN_NACCC,
  AUTH_NACCC_TOKEN,
  AUTH_FALLBACK_URL,
  AUTH_HERITAGE_JOURNEY,
  AUTH_SET_REDIRECT_LINK,
  AUTH_SET_AGREED_TO_TERMS,
  AUTH_SET_AGREED_TO_PROMOTIONS,
  AUTH_DISPATCH_SET_AGREEMENTS,
  AUTH_DISPATCH_GET_HERITAGE_ID,
  AUTH_DISPATCH_GUEST_LOGIN,
  AUTH_SET_GUEST_LOGIN,
  AUTH_DISPATCH_GUEST_LOGOUT,
  AUTH_GUEST_LOGOUT,
} from '../types'
import axios from 'axios'

import { 
  API_URL, 
  CHATBOT_CUSTOMER, 
  MERCHANT, 
  SINGPASS_LOGIN_URL 
} from '@/config/constants'

import VuexPersistence from 'vuex-persist'

import { get } from 'lodash-es'
import qs from 'qs'
import router from '@/router'
import { RootState } from '..'
import { toError } from '@/utils/error'

export interface IAuthState {
  id?: string;
  token?: string;
  otpToken?: string;
  chatbotCustomer?: string;
  merchant?: string;
  iat?: string;
  number?: string;
  otpType?: string;
  email?: string;
  phone_number?: string;
  birthDate?: string;
  nationality?: string;
  address?: {
    postal?: string;
  };
  otpSentTime?: number;
  redirectPathAfterAuth?: string;
  redirectLinkAfterAuth?: string;
  has_nric: boolean;
  isSingaporean: boolean;
  setupComplete: boolean;
  firstName: string;
  lastName: string;
  heritageId: string;
  heritageIdQrcode: string;
  isVerifiedBySingpass?: boolean;
  userSingpass?: IUserSingpass;
  statusSingpass?: string;
  errorSingpass?: string;
  isFoundAnotherAccount: boolean;
  giftInfo: boolean;
  giftRedeem: boolean;
  expiredToken: boolean;
  expiredTokenNaccc: boolean;
  fallbackURL?: string;
  naccc_token: string | null;
  heritage_journey: boolean;
  force_redirect?: boolean;
  session?: string;
  agreedToTerms?: boolean;
  agreedToPromotions?: boolean;
  isGuestLogin?: boolean;
}

interface IRegisterPOJO {
  need_otp: boolean;
  otp_key: string;
}

interface IVerifyOTPPOJO {
  ticketing_token: string;
  isNeedLinked: boolean;
}

interface ILoginSingpass {
  isFoundAnotherAccount: boolean;
  ticketing_token: string;
  isVerifiedBySingpass: boolean;
  status: string;
  error: string;
}

export interface IUserSingpassDependent {
  n4: string;
  birthDate: string;
  nationality: string;
  age: number;
  race: string;
  residentialStatus: string;
  secondaryRace: string;
}

interface IGetHeritageIdPOJO {
  heritageId: string;
}

export interface IUserSingpass {
  firstname: string;
  lastname: string;
  n4: string;
  phone_number: string;
  email: string;
  birthDate: string;
  nationality: string;
  address: {
    block: string;
    street: string;
    postal: string;
  };
  dependents: IUserSingpassDependent[];
  race: string;
  sex: string;
  isSingaporean: boolean;
}

interface IMePOJO {
  id: string;
  phone_number: string;
  has_nric: boolean;
  setup_complete: boolean;
  email: string;
  firstName: string;
  lastName: string;
  birthDate: string;
  nationality: string;
  address: {
    postal: string;
  };
  heritageId: string;
  heritageIdQrcode: string;
  isSingaporean: boolean;
}

interface Query {
  path: string;
  iat: string;
  hideBackToChat: string;
  session?: string;
}

const state: IAuthState = {
  id: undefined,
  token: undefined,
  otpToken: undefined,
  chatbotCustomer: CHATBOT_CUSTOMER,
  merchant: MERCHANT,
  iat: '',
  email: '',
  number: '',
  otpType: '',
  firstName: '',
  lastName: '',
  phone_number: '',
  birthDate: '',
  nationality: '',
  address: {
    postal: '',
  },
  heritageId: '',
  heritageIdQrcode: '',
  has_nric: false,
  isSingaporean: false,
  setupComplete: false,
  otpSentTime: undefined,
  isVerifiedBySingpass: undefined,
  userSingpass: undefined,
  statusSingpass: undefined,
  errorSingpass: undefined,
  isFoundAnotherAccount: false,
  giftInfo: false,
  giftRedeem: false,
  expiredToken: false,
  expiredTokenNaccc: false,
  fallbackURL: undefined,
  naccc_token: null,
  heritage_journey: false,
  force_redirect: false,
  session: undefined,
  agreedToTerms: undefined,
  agreedToPromotions: undefined,
  isGuestLogin: false,
}

const getters: GetterTree<IAuthState, RootState> = {
  getToken: (state) => state.token,
  getOTPToken: (state) => state.otpToken,
  isAuthenticated: (state) => !!state.token,
  isSetupComplete: (state) => state.setupComplete,
  otpSentTime: (state) => state.otpSentTime,
  merchant: (state) => state.merchant,
  customer: (state) => state.chatbotCustomer,
  isVerifiedBySingpass: (state) => state.isVerifiedBySingpass,
  isFoundAnotherAccount: (state) => state.isFoundAnotherAccount,
  userSingpass: (state) => state.userSingpass,
  statusSingpass: (state) => state.statusSingpass,
  errorSingpass: (state) => state.errorSingpass,
  webUrlSingpass: (state) => {
    const isCheckoutAuth = router.currentRoute.path.includes('checkout')
    const singpassUrl = SINGPASS_LOGIN_URL
    let redirect: URL | null = null

    if (state.fallbackURL) {
      redirect = new URL(state.fallbackURL)
      const vquery = redirect.searchParams.get('vquery')

      if (vquery && vquery.startsWith('ATT_')) {
        const queryJSON = vquery.replace('ATT_', '')
        const query: Query = JSON.parse(queryJSON)
        query.path = isCheckoutAuth ? 'checkout' : 'auth',
        query.iat = state.iat ?? ''
        
        if (state.session) {
          query.session = state.session
        }
        
        redirect.searchParams.set('vquery', `ATT_${JSON.stringify(query)}`)
      } else {
        const query: Query = {
          path: isCheckoutAuth ? 'checkout' : 'auth',
          iat: state.iat ?? '',
          hideBackToChat: '0'
        }

        if (state.session) {
          query.session = state.session
        }

        redirect.searchParams.set('vquery', `ATT_${JSON.stringify(query)}`)
      }
    }

    const sid: {
      merchant?: string;
      customer?: string;
      iat?: string;
      redirect?: string;
      session?: string;
    } = {
      merchant: state.merchant,
      customer: state.chatbotCustomer,
      iat: state.iat,
      redirect: encodeURIComponent(redirect?.href ?? '')
    }

    if (state.session) {
      sid.session = state.session
    }

    return `${singpassUrl}?sid=ATT_${btoa(qs.stringify(sid))}`
  },
  iat: (state) => state.iat,
  giftInfo: (state) => state.giftInfo,
  giftRedeem: (state) => state.giftRedeem,
  expiredToken: (state) => state.expiredToken,
  expiredTokenNaccc: (state) => state.expiredTokenNaccc,
  fallbackURL: (state) => state.fallbackURL,
  naccc_token: (state) => state.naccc_token,
  has_nric: (state) => state.has_nric,
  isSingaporeanPr: (state) => state.isSingaporean,
  me: (state) => ({
    firstName: state.firstName,
    lastName: state.lastName,
    birthDate: state.birthDate,
    nationality: state.nationality,
    isSingaporean: state.isSingaporean
  }),
  isNACCMerchant: (state) => {
    const allowMerchants = [
      '63a3cbbd0880a100139c416e', //NaccMerchantUat
      '63c123a3aad4550013535c9e', //NacccMerchantPRD
      // "5f5edf3af459fe0022be83de", //portaluat
    ]
    return state.merchant && allowMerchants.includes(state.merchant)
  },
  isCMSGMerchant: (state) => {
    const allowMerchants = [
      '6268a344067df30016385eb7', //cmsgmerchant prd
      '5f5edf3af459fe0022be83de', //portaluat
      '60a28c0260d99a0016400a6d', //v360 nhb(dev) uat
    ]
    return state.merchant && allowMerchants.includes(state.merchant)
  },
  isNMSMerchant: (state) => {
    const allowMerchants = [
      '615675f3820e0b0016ae8bfc', //nmsmerchant prd
    ]
    return state.merchant && allowMerchants.includes(state.merchant)
  },
  heritage_journey: (state) => state.heritage_journey,
  force_redirect: (state) => state.force_redirect,
  redirect_link: (state) => state.redirectLinkAfterAuth,
  session: (state) => state.session,
  userId: (state) => state.id,
  isGuestLogin: (state) => state.isGuestLogin,
}

const mutations: MutationTree<IAuthState> = {
  [AUTH_SET_TOKEN](state, payload: { token: string }) {
    state.token = payload.token
  },
  [AUTH_SET_IAT](state, payload: { iat: string }) {
    state.iat = payload.iat
  },
  [AUTH_SET_SETUP_COMPLETE](
    state,
    payload: {
      setup_complete: boolean;
      email: string;
      firstName: string;
      lastName: string;
      id: string;
    }
  ) {
    state.setupComplete = payload.setup_complete
    state.email = payload.email
    state.firstName = payload.firstName
    state.lastName = payload.lastName
    state.id = payload.id
  },
  [AUTH_SET_OTP_TOKEN](state, payload: { token: string }) {
    state.otpToken = payload.token
  },
  [AUTH_SET_OTP_NUMBER](state, payload: { number: string }) {
    state.number = payload.number
    state.email = undefined
  },
  [AUTH_SET_OTP_EMAIL](state, payload: { email: string }) {
    state.email = payload.email
    state.number = undefined
  },
  [AUTH_SET_OTP_TYPE](state, payload: { otpType: string }) {
    state.otpType = payload.otpType
  },
  [AUTH_SIGN_OUT](state) {
    state.id = undefined
    state.token = undefined
    state.otpToken = undefined
    state.phone_number = ''
    state.birthDate = ''
    state.address = {
      postal: '',
    }
    state.email = ''
    state.number = ''
    state.otpType = ''
    state.firstName = ''
    state.lastName = ''
    state.heritageId = ''
    state.heritageIdQrcode = ''
    state.setupComplete = false
    state.otpSentTime = undefined
    state.iat = '',
    state.isVerifiedBySingpass = undefined
    state.userSingpass = undefined
    state.statusSingpass = undefined
    state.errorSingpass = undefined
    state.isFoundAnotherAccount = false
    state.giftInfo = false
    state.giftRedeem = false
    state.expiredToken = false
    state.expiredTokenNaccc = false
    state.isGuestLogin = false
  },
  [AUTH_SET_REDIRECT](state, redirect) {
    state.redirectPathAfterAuth = redirect
  },
  [AUTH_SET_REDIRECT_LINK](state, redirect) {
    state.redirectLinkAfterAuth = redirect
  },
  [AUTH_SET_CREDENTIAL](
    state,
    payload: { customerId: string; merchant: string }
  ) {
    state.merchant = payload.merchant
    state.chatbotCustomer = payload.customerId
  },
  [AUTH_SET_OTP_SENT_TIME](state) {
    state.otpSentTime = Date.now()
  },
  [AUTH_UNSET_OTP_SENT_TIME](state) {
    state.otpSentTime = undefined
  },
  [AUTH_SET_PROFILE](
    state,
    payload: { 
      email: string; 
      firstName: string; 
      lastName: string;
      phone_number: string;
      birthDate: string;
      nationality: string;
      has_nric: boolean;
      isSingaporean: boolean;
      address: {
        postal: string;
      };
      heritageId: string; 
      heritageIdQrcode: string;
      id: string;
    }
  ) {
    state.email = payload.email
    state.firstName = payload.firstName
    state.lastName = payload.lastName
    state.phone_number = payload.phone_number
    state.birthDate = payload.birthDate
    state.nationality = payload.nationality
    state.has_nric = payload.has_nric
    state.isSingaporean = payload.isSingaporean
    state.address = payload.address
    state.heritageId = payload.heritageId
    state.heritageIdQrcode = payload.heritageIdQrcode
    state.id = payload.id
  },
  [AUTH_SET_USER_SINGPASS](
    state,
    payload: { userSingpass: IUserSingpass }
  ) {
    state.userSingpass = payload.userSingpass
  },
  [AUTH_SET_STATUS_SINGPASS](
    state,
    payload: { statusSingpass: string | undefined }
  ) {
    state.statusSingpass = payload.statusSingpass
  },
  [AUTH_SET_ERROR_SINGPASS](
    state,
    payload: { errorSingpass: string | undefined }
  ) {
    state.errorSingpass = payload.errorSingpass
  },
  [AUTH_SET_ISVERIFY_SINGPASS](state, payload: { isVerifiedBySingpass: boolean }) {
    state.isVerifiedBySingpass = payload.isVerifiedBySingpass
  },
  [AUTH_SET_ISFOUND_ANOTHER_ACCOUNT](state, payload: { isFoundAnotherAccount: boolean }) {
    state.isFoundAnotherAccount = payload.isFoundAnotherAccount
  },
  [AUTH_GIFT_INFO](state) {
    state.giftInfo = true
  },
  [AUTH_GIFT_REDEEM](state) {
    state.giftRedeem = true
  },
  [AUTH_EXPIRED_TOKEN](state, expiredToken: boolean) {
    state.expiredToken = expiredToken
  },
  [AUTH_EXPIRED_TOKEN_NACCC](state, expiredTokenNaccc: boolean) {
    state.expiredTokenNaccc = expiredTokenNaccc
  },
  [AUTH_NACCC_TOKEN](state, naccc_token) {
    state.naccc_token = naccc_token
  },
  [AUTH_FALLBACK_URL](state, fallbackURL: string) {
    state.fallbackURL = fallbackURL
  },
  [AUTH_HERITAGE_JOURNEY](state, heritage_journey) {
    state.heritage_journey = heritage_journey
  },
  [AUTH_SET_FORCE_REDIRECT](state, force_redirect) {
    state.force_redirect = force_redirect
  },
  [AUTH_SET_SESSION](state, session) {
    state.session = session
  },
  [AUTH_SET_AGREED_TO_TERMS](state, agreedToTerms: boolean) {
    state.agreedToTerms = agreedToTerms
  },
  [AUTH_SET_AGREED_TO_PROMOTIONS](state, agreedToPromotions: boolean) {
    state.agreedToPromotions = agreedToPromotions
  },
  [AUTH_SET_GUEST_LOGIN](state, isGuestLogin: boolean) {
    state.isGuestLogin = isGuestLogin
  },
  [AUTH_GUEST_LOGOUT](state) {
    state.id = undefined
    state.token = undefined
    state.email = ''
    state.firstName = ''
    state.lastName = ''
    state.setupComplete = false
    state.isGuestLogin = false
  },
}

const actions: ActionTree<IAuthState, RootState> = { 
  [AUTH_DISPATCH_RESEND_OTP]: async ({ state, commit }) => {
    const email = state.email
    if (!email) return router.replace({ name: 'Auth', params: { login: 'email' } })

    const resp = await axios.post<{ resent: boolean; otp_key: string }>(
      `${API_URL}/api/v1/auth/resend-otp`,
      JSON.stringify({ email }),
      { headers: { 'Content-Type': 'application/json' } }
    )
    commit(AUTH_SET_OTP_TOKEN, { token: resp.data.otp_key })
    commit(AUTH_SET_OTP_SENT_TIME)
  },

  [AUTH_DISPATCH_SIGNUP]: async (
    { commit },
    payload: { phoneNumber: string }
  ) => {
    const _phoneNumber = payload.phoneNumber.replace(/\s/g, '').trim()

    try {
      const resp = await axios.post<IRegisterPOJO>(
        `${API_URL}/api/v1/auth/register`,
        JSON.stringify({
          phone_number: _phoneNumber,
        }),
        {
          headers: {
            'Content-Type': 'application/json',
          },
        }
      )
      commit(AUTH_SET_OTP_TOKEN, { token: resp.data.otp_key })
      commit(AUTH_SET_OTP_NUMBER, { number: payload.phoneNumber })
      commit(AUTH_SET_OTP_SENT_TIME)
    } catch (e) {
      const data = get(e, 'response.data')
      if (data) throw data
    }
  },

  [AUTH_DISPATCH_LOGIN_SINGPASS]: async (
    { commit, state, rootGetters },
  ) => {
    try {
      const chatbot_customer = state.chatbotCustomer
      const apiKey = rootGetters.apiKey
      const resp = await axios.get<ILoginSingpass>(
        `${API_URL}/api/v1/users/singpass/login?customer=${chatbot_customer}&iat=${state.iat}`,
        {
          headers: {
            'Content-Type': 'application/json',
            'api-key': apiKey,
          },
        }
      )
      commit(AUTH_SET_TOKEN, { token: resp.data.ticketing_token })
      commit(AUTH_SET_ISVERIFY_SINGPASS, { isVerifiedBySingpass: resp.data.isVerifiedBySingpass })
      commit(AUTH_SET_ISFOUND_ANOTHER_ACCOUNT, { isFoundAnotherAccount: resp.data.isFoundAnotherAccount })
      commit(AUTH_SET_STATUS_SINGPASS, { statusSingpass: resp.data.status })
    } catch (e) {
      if (axios.isAxiosError(e) && e.response) {
        const data = get(e, 'response.data')
        commit(AUTH_SET_ERROR_SINGPASS, { errorSingpass: data.message })
        if (data) throw data
      }
    }
  },

  [AUTH_DISPATCH_LOGIN]: async (
    { commit },
    payload: { phoneNumber?: string, email?: string, captcha: string }
  ) => {
    const _phoneNumber = payload.phoneNumber?.replace(/\s/g, '').trim() ?? undefined

    try {
      const resp = await axios.post<IRegisterPOJO>(
        `${API_URL}/api/v1/auth/login`,
        JSON.stringify({
          phone_number: _phoneNumber,
          email: payload.email ?? undefined,
          captcha: payload.captcha
        }),
        {
          headers: {
            'Content-Type': 'application/json',
          },
        }
      )

      if (payload.phoneNumber) {
        commit(AUTH_SET_OTP_NUMBER, { number: payload.phoneNumber })
      } else {
        commit(AUTH_SET_OTP_EMAIL, { email: payload.email })
      }
      commit(AUTH_SET_OTP_TOKEN, { token: resp.data.otp_key })
      commit(AUTH_SET_OTP_SENT_TIME)
    } catch (e) {
      const data = get(e, 'response.data')
      if (data) throw data
    }
  },

  [AUTH_DISPATCH_VERIFY_OTP]: async (
    { commit, state, dispatch, rootGetters },
    payload: { otp: string }
  ) => {
    const otpKey = state.otpToken
    const chatbotCustomer = state.chatbotCustomer
    const merchant = state.merchant
    const session = state.session ?? undefined
    
    try {
      if (!otpKey || !chatbotCustomer || !merchant)
        throw new Error('incomplete data')
      const resp = await axios.post<IVerifyOTPPOJO>(
        `${API_URL}/api/v1/auth/verify-otp`,
        JSON.stringify({
          otp: payload.otp,
          otp_key: otpKey,
          chatbot_customer: chatbotCustomer,
          merchant: merchant,
          session: session,
        }),
        {
          headers: {
            'Content-Type': 'application/json',
          },
        }
      )
      commit(AUTH_SET_TOKEN, { token: resp.data.ticketing_token })
      if (rootGetters.apiKey) {
        dispatch('loadCredentials')
      }
      dispatch(AUTH_DISPATCH_SET_AGREEMENTS)
      dispatch('checkExist')
      const meResp = await axios.get<IMePOJO>(`${API_URL}/api/v1/auth/me`, {
        headers: {
          'Content-Type': 'application/json',
          'x-ticket-token': resp.data.ticketing_token,
        },
      })
      commit(AUTH_SET_SETUP_COMPLETE, {
        setup_complete: meResp.data.setup_complete,
        email: meResp.data.email,
        firstName: meResp.data.firstName,
        lastName: meResp.data.lastName,
        id: meResp.data.id,
      })
      commit(AUTH_UNSET_OTP_SENT_TIME)

      return { isNeedLinked: resp.data.isNeedLinked }
    } catch(err) {
      throw toError(err)
    }
  },

  [AUTH_DISPATCH_LOGOUT]: async ({ commit, state }) => {
    try {
      const token = state.token
      if (!token) throw new Error('need token')
      
      await axios.post(`${API_URL}/api/v1/users/logout`, {}, {
        headers: {
          'Content-Type': 'application/json',
          'x-ticket-token': token,
        }
      })
      commit(AUTH_SIGN_OUT)
    } catch (e) {
      const data = get(e, 'response.data')
      if (data) throw data
    }
  },

  [AUTH_DISPATCH_LOAD_PROFILE]: async ({ state, commit, dispatch, rootGetters }): Promise<IMePOJO> => {
    const token = state.token
    if (!token) throw new Error('need token')

    const resp = await axios.get<IMePOJO>(`${API_URL}/api/v1/auth/me`, {
      headers: {
        'Content-Type': 'application/json',
        'x-ticket-token': token,
      },
    })
    
    try {
      commit(AUTH_SET_PROFILE, {
        phone_number: resp.data.phone_number,
        email: resp.data.email,
        firstName: resp.data.firstName,
        lastName: resp.data.lastName,
        birthDate: resp.data.birthDate,
        nationality: resp.data.nationality,
        has_nric: resp.data.has_nric,
        isSingaporean: resp.data.isSingaporean,
        address: resp.data.address,
        heritageId: resp.data.heritageId,
        heritageIdQrcode: resp.data.heritageIdQrcode,
        id: resp.data.id,
      })

      if (rootGetters.apiKey) {
        dispatch('loadCredentials')
      }
    } catch(err) {
      console.log(err)
    }
    return resp.data
  },

  [AUTH_DISPATCH_LOAD_USER_SINGPASS]: async ({ state, commit }): Promise<IUserSingpass> => {
    const token = state.token
    if (!token) throw new Error('need token')

    const resp = await axios.get<IUserSingpass>(`${API_URL}/api/v1/users/singpass?fields=address,dependents,race,sex`, {
      headers: {
        'Content-Type': 'application/json',
        'x-ticket-token': token,
      },
    })
    
    try {
      commit(AUTH_SET_USER_SINGPASS, { userSingpass: resp.data })
    } catch(err) {
      console.log(err)
    }
    return resp.data
  },

  [AUTH_DISPATCH_SET_EMAIL]: async (
    { state, commit },
    payload: { email: string }
  ): Promise<boolean> => {
    const token = state.token
    if (!token) throw new Error('need token')

    const resp = await axios.put<boolean>(
      `${API_URL}/api/v1/auth/me/email`,
      { email: payload.email },
      {
        headers: {
          'Content-Type': 'application/json',
          'x-ticket-token': token,
        },
      }
    )

    const setup = await axios.get<IMePOJO>(`${API_URL}/api/v1/auth/me`, {
      headers: {
        'Content-Type': 'application/json',
        'x-ticket-token': token,
      },
    })
    commit(AUTH_SET_SETUP_COMPLETE, {
      setup_complete: setup.data.setup_complete,
      email: setup.data.email,
      firstName: setup.data.firstName,
      lastName: setup.data.lastName,
      id: setup.data.id,
    })

    return resp.data
  },

  [AUTH_DISPATCH_SET_NRIC]: async (
    { state, commit },
    payload: { nric: string }
  ): Promise<boolean> => {
    const token = state.token
    if (!token) throw new Error('need token')

    const resp = await axios.put<boolean>(
      `${API_URL}/api/v1/auth/me/nric`,
      {
        nric: payload.nric,
      },
      {
        headers: {
          'Content-Type': 'application/json',
          'x-ticket-token': token,
        },
      }
    )

    const setup = await axios.get<IMePOJO>(`${API_URL}/api/v1/auth/me`, {
      headers: {
        'Content-Type': 'application/json',
        'x-ticket-token': token,
      },
    })
    commit(AUTH_SET_SETUP_COMPLETE, {
      setup_complete: setup.data.setup_complete,
      email: setup.data.email,
      firstName: setup.data.firstName,
      lastName: setup.data.lastName,
      id: setup.data.id,
    })

    return resp.data
  },

  [AUTH_DISPATCH_REMOVE_NRIC]: async (
    { state },
  ): Promise<void> => {
    const token = state.token
    if (!token) throw new Error('need token')

    await axios.put(
      `${API_URL}/api/v1/users/remove-nric`,
      {},
      {
        headers: {
          'Content-Type': 'application/json',
          'x-ticket-token': token,
        },
      }
    )
  },

  [AUTH_DISPATCH_TOKEN_NACCC]: async (
    {commit, state},
  ): Promise<boolean> => {
    try {
      const tokenNaccc = state.naccc_token
      if(!tokenNaccc) throw new Error('need token naccc')
      const resp = await axios.get<boolean>(
        `${API_URL}/api/v1/users/naccc/login/status`,
        {
          headers: {
            'Content-Type': 'application/json',
            'x-naccc-token': tokenNaccc,
          }
        }
      )
      if(resp.data !== true) {
        commit(AUTH_EXPIRED_TOKEN_NACCC, true)
      }

      return resp.data
    } catch (e) {
      commit(AUTH_EXPIRED_TOKEN_NACCC, true)

      return false
    }
  },
  [AUTH_DISPATCH_SET_AGREEMENTS]: async (
    { state }
  ): Promise<void> => {
    try {
      const token = state.token
      if (!token) throw new Error('need token')
      
      await axios.post(`${API_URL}/api/v1/users/agreements`, {
        agreedToTerms: state.agreedToTerms,
        agreedToPromotions: state.agreedToPromotions,
      }, {
        headers: {
          'Content-Type': 'application/json',
          'x-ticket-token': token,
        },
      })
    } catch (e) {
      const data = get(e, 'response.data')
      if (data) throw data
    }
  },

  [AUTH_DISPATCH_GET_HERITAGE_ID]: async (
    { state },
    payload: {
      name: string,
      email: string,
      phoneNumber: string,
    }
  ): Promise<string> => {
    const resp = await axios.post<IGetHeritageIdPOJO>(
      `${API_URL}/api/v1/auth/get-heritage-id`,
      {
        name: payload.name,
        email: payload.email,
        phoneNumber: payload.phoneNumber,
        merchant: state.merchant,
        chatbotCustomer: state.chatbotCustomer
      }, {
        headers: {
          'Content-Type': 'application/json',
        },
      }
    )
    return resp.data.heritageId
  },

  [AUTH_DISPATCH_GUEST_LOGIN]: async ({ commit, state, rootGetters }) => {
    try {
      // Check if Culture Pass is enabled before allowing guest login
      const isCulturePassEnable = rootGetters.isCulturePassEnable
      if (!isCulturePassEnable) {
        throw new Error('Guest login is not available - Culture Pass is not enabled')
      }

      const chatbotCustomer = state.chatbotCustomer
      const merchant = state.merchant
      const session = state.session ?? undefined
      const apiKey = rootGetters.apiKey
      
      if (!chatbotCustomer || !merchant) {
        throw new Error('Missing required credentials for guest login')
      }

      const resp = await axios.post<{ ticketing_token: string, guestUserId: string }>(
        `${API_URL}/api/v1/auth/guest-login`,
        JSON.stringify({
          chatbot_customer: chatbotCustomer,
          merchant: merchant,
          session: session,
        }),
        {
          headers: {
            'Content-Type': 'application/json',
            'api-key': apiKey,
          },
        }
      )
      
      commit(AUTH_SET_TOKEN, { token: resp.data.ticketing_token })
      commit(AUTH_SET_GUEST_LOGIN, true)
      commit(AUTH_SET_SETUP_COMPLETE, {
        setup_complete: true,
        email: 'guest@example.com',
        firstName: 'Guest',
        lastName: 'User',
        id: resp.data.guestUserId,
      })
      
      return { success: true, token: resp.data.ticketing_token }
    } catch (e) {
      const data = get(e, 'response.data')
      if (data) throw data
      throw e
    }
  },

  [AUTH_DISPATCH_GUEST_LOGOUT]: async ({ commit, state }) => {
    if (state.isGuestLogin) {
      commit(AUTH_GUEST_LOGOUT)
      return { success: true }
    }
    return { success: false, message: 'Not logged in with guest credentials' }
  },
}

const VuexLocal = new VuexPersistence({
  storage: window.localStorage,
}) 

export default {
  state,
  getters,
  actions,
  mutations,
  plugins: [VuexLocal.plugin],
}
